import memoizeResult from '../../memoize-result.js'

const featuresAsArray = memoizeResult(state => Object.values(state.features))

/*
 * Return the Feature with the given Geometry's id
 * @sig firstFeatureForGeometryId :: (State, Id) -> Feature|undefined
 */
const firstFeatureForGeometryId = (state, geometryId) => featuresAsArray(state).find(f => f.geometryId === geometryId)

const FeatureSelectors = {
    featuresAsArray,
    firstFeatureForGeometryId,
}

export default FeatureSelectors
